export default Object.freeze({
    "0": "Africa/Freetown",
    "+1": "Africa/El_Aaiun",
    "+2": "Africa/Harare",
    "+3": "Africa/Kampala",
    "+4": "Europe/Astrakhan",
    "+5": "Indian/Kerguelen",
    "+6": "Antarctica/Vostok",
    "+7": "Asia/Bangkok",
    "+8": "Asia/Brunei",
    "+9": "Asia/Chita",
    "+10": "Asia/Ust-Nera",
    "+11": "Asia/Sakhalin",
    "+12": "Asia/Anadyr",
    "-12": "Etc/GMT+12",
    "-11": "Pacific/Niue",
    "-10": "Pacific/Rarotonga",
    "-9": "Pacific/Gambier",
    "-8": "Pacific/Pitcairn",
    "-7": "Etc/GMT+7",
    "-6": "Pacific/Galapagos",
    "-5": "America/Bogota",
    "-4": "America/Campo_Grande",
    "-3": "America/Buenos_Aires",
    "-2": "Atlantic/South_Georgia",
    "-1": "Atlantic/Cape_Verde",
})